import styled from "styled-components";

export const Wraper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

`

export const ButtonsWrapper = styled.div`

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
`
